import { useEffect, useState } from 'react'

/**
 * Devuelve el valor "frenado": recién se actualiza cuando pasaron `ms` sin
 * cambios. Para buscadores de listados: el input usa el valor vivo, el fetch
 * depende del debounced — así tipear no dispara un request por tecla
 * (auditoría 1 jul 2026; mismo criterio que ClientesPage, 350 ms).
 */
export default function useDebounce(value, ms = 350) {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms)
    return () => clearTimeout(t)
  }, [value, ms])

  return debounced
}
